import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Globe } from 'lucide-react';

const JobPortalHeader = () => {
    const [content, setContent] = useState<any>({});
    const { language, toggleLanguage, t, t_api } = useLanguage();

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const res = await fetch('/api/content/Careers_Portal');
                if (res.ok) {
                    const data = await res.json();
                    setContent(data);
                }
            } catch (err) {
                console.error("Header content fetch failed", err);
            }
        };
        fetchContent();
    }, []);

    return (
        <header className="w-full bg-white shadow-md fixed top-0 z-[100] font-sans border-b-[6px] border-red-600">
            <div className="max-w-7xl mx-auto px-6 md:px-8 flex items-center justify-between py-4">
                <div className="flex items-center gap-12">
                    <Link to="/" className="shrink-0">
                        <img 
                            src={content.header_logo ? `https://hamdanoman.com${content.header_logo}` : '/about.jpeg'} 
                            alt="Hamdan Logo" 
                            className="h-8 md:h-10 object-contain" 
                        />
                    </Link>
                    <nav className="hidden md:flex items-center gap-8">
                        <a href="/job-portal/jobs" className="text-[11px] font-black text-slate-800 hover:text-red-600 uppercase tracking-[0.2em] transition-colors">
                            {language === 'ar' ? 'جميع الوظائف' : 'All Jobs'}
                        </a>
                    </nav>
                </div>
                
                <div className="flex items-center gap-6 md:gap-10">
                    <a href="/job-portal#why-join" className="hidden lg:block text-[11px] font-black text-slate-800 hover:text-red-600 uppercase tracking-[0.2em] transition-colors">
                        {t_api(content.header_nav_text || 'Why join Hamdan Trading Group?', content.header_nav_text_ar)}
                    </a>

                    <button
                        onClick={toggleLanguage}
                        className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-800 text-xs font-bold transition-all border border-slate-300"
                    >
                        <Globe className="w-4 h-4 text-red-600" />
                        <span>{language === 'en' ? 'العربية' : 'English'}</span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default JobPortalHeader;
